/**
 * Shared Tailwind class helpers for field components. `overridden` marks debit
 * and dollar overrides; `synthetic` marks engine-generated rows.
 */
export type FieldState = "default" | "error" | "readonly" | "overridden" | "synthetic";

export function resolveFieldState(opts: { error?: string | null; readOnly?: boolean; isOverridden?: boolean }): FieldState {
  if (opts.error) return "error";
  if (opts.readOnly) return "readonly";
  if (opts.isOverridden) return "overridden";
  return "default";
}

const STATE_CLASSES: Record<FieldState, string> = {
  default: "border-gray-300 bg-white text-gray-900",
  error: "border-danger bg-danger-bg text-gray-900",
  readonly: "border-gray-200 bg-gray-50 text-gray-700",
  overridden: "border-brand-green bg-brand-green-05 text-gray-900",
  synthetic: "border-gray-200 bg-gray-50 text-gray-500 italic",
};

export const FOCUS_RING = "focus:outline-none focus:ring-2 focus:ring-brand-green-50 focus:border-brand-green";

export function inputClass(state: FieldState = "default", size: "default" | "sm" = "default"): string {
  const sizing = size === "sm" ? "px-2 py-1 text-sm" : "px-3 py-2.5 text-base sm:text-sm";
  return `w-full rounded-lg border ${sizing} ${FOCUS_RING} ${STATE_CLASSES[state]}`;
}

export function labelClass(): string {
  return "block text-sm font-medium text-gray-700 mb-1";
}

export function fieldIds(id: string, error?: string | null, hint?: string | null) {
  const errorId = error ? `${id}-error` : undefined;
  const hintId = hint ? `${id}-hint` : undefined;
  return { errorId, hintId, describedBy: [errorId, hintId].filter(Boolean).join(" ") || undefined };
}
